/**
 * @param
 * @field /mobile/record/v1/msg/action/callback
 * @method POST
 * @name message
 * @description
 */
export interface IRequestActionByContentCallbackParams {
  recordUid: string;
  tplUid: string;
  tplType: string;
  contentCallback?: string;
}

/**
 * @returns
 * @description
 * @global
 */
export type IRequestActionByContentCallbackResponse = {
  statusCode: number;
  data?: boolean;
  message?: string;
};


/**
 * @param
 * @field /mobile/record/items
 * @method GET
 * @name message
 * @description 获取二级消息列表
 */
export interface IGetNotificationListParams {
  userUid: string;
  groupUid: string;
  pageSize: number;
  queryTime?: number;
  id?: number;
}

/**
 * @returns
 * @description 返回二级消息列表
 * @global
 */
export type IGetNotificationListResponse = TNotification[];

export enum ENotificationStyle {
  notification = 1,
  card = 2
}

/**
 * @global
 */
export type TNotification = {
  id: number;
  uid: string;
  tplUid: string;
  tplType: string;
  msgStyle?: number; // 1 - 通知型样式，2 - 卡片型样式，3 - 提醒弹窗（底部）
  groupUid: string;
  title: string;
  typeName: string;
  creatorUid?: string;
  creatorName?: string;
  createTime?: number;
  photo?: string;
  body?: string;
  action?: string;
  bizUniqueKey?: string;
  hasRead?: boolean;
  needValidate?: boolean;

  photoInfo?: TNotificationPhotoInfo;
  bodyInfo?: TNotificationBody;
  actionInfo?: TNotificationActionInfo;

  groupTime?: number;
}

/**
 * @global
 */
export type TNotificationPhotoInfo = {
  coverPhoto?: TNotificationPhoto;
  photo1: TNotificationPhoto;
  photo2: TNotificationPhoto;
  photo3?: TNotificationPhoto;
  photo4?: TNotificationPhoto;
  photo5?: TNotificationPhoto;
  photo6?: TNotificationPhoto;
}

/**
 * @global
 */
export type TNotificationPhoto = {
  url?: string;
  action?: TNotificationAction;
}

/**
 * @global
 */
export type TNotificationBody = {
  headData?: TNotificationBodyHeadData;
  alertData?: TNotificationBodyAlertData;
  data1?: TNotificationBodyData;
  data2?: TNotificationBodyData;
  data3?: TNotificationBodyData;
  data4?: TNotificationBodyData;
  data5?: TNotificationBodyData;
  data6?: TNotificationBodyData;
  rich1?: TNotificationBodyRichTextData;
  rich2?: TNotificationBodyRichTextData;
  rich3?: TNotificationBodyRichTextData;
  tailData?: TNotificationBodyTailData;
}

/**
 * @global
 */
export type TNotificationBodyHeadData = {
  content?: string;
  contentColor?: string;
}

/**
 * @global
 */
export type TNotificationBodyAlertData = {
  content?: string;
  contentColor?: string;
}

/**
 * @global
 */
export type TNotificationBodyData = {
  icon?: string;
  label: string;
  content: string;
  contentColor?: string;
  bold?: boolean;
  hyperlink?: string;
}

/**
 * @global
 */
export type TNotificationBodyRichTextData = {
  texts?: TNotificationBodyData[];
}

/**
 * @global
 */
export type TNotificationBodyTailData = {
  content?: string;
  contentColor?: string;
}

/**
 * @global
 */
export type TNotificationAction = {
  name?: string;
  url?: string;
  h5Url?: string;
  path?: string;
  pathExtras?: any;
  fridayDesc?: any;
  contentCallback?: string;
}

/**
 * @global
 */
export type TNotificationActionInfo = {
  action1: TNotificationAction;
  action2: TNotificationAction;
  action3: TNotificationAction;
  popupMenuAction?: TNotificationAction[];
}